import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { PartnerComponent } from './partner.component';

/**
 * 取引先等初期表示画面 モジュール設定クラス
 *
 * @export PartnerModule
 * @class PartnerModule
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    PartnerComponent,
  ]
})
export class PartnerModule {

}
